module.exports = "<div class=smss-field ng-class=\"{ 'smss-field--inline': inline}\"></div> ";